interface EventD {
	list: any
}

export default class Event implements EventD {
	list = new Map()

	on(event: string, callback: any) {
		if (!this.list.has(event)) {
			this.list.set(event, [])
		}
		this.list.get(event).push(callback)
		return this
	}

	off(event: string) {
		this.list.delete(event)
		return this
	}

	emit(event: string, ...args: any) {
		if (this.list.has(event)) {
			this.list.get(event).forEach((callback: any) => setTimeout(() => callback(...args), 0))
		}
	}
}
